/** Manages the task form state by delegating to specialized sub-hooks. */
// @ts-check
import { useState } from 'react';
import { useTasksContext } from '@/features/tasks/context/TasksContext.def';
import { useTaskFormValidation } from '@/features/tasks/hooks/form/use-task-form-validation';
import { useTaskFormSubtasks } from '@/features/tasks/hooks/form/use-task-form-subtasks';
import { useTaskFormOptions } from '@/features/tasks/hooks/form/use-task-form-options';
import { useTaskFormHandlers } from '@/features/tasks/hooks/form/use-task-form-handlers';
import { buildInitialTaskFormState } from '@/features/tasks/hooks/form/use-task-form.helpers';
import { useTaskFormRecurrence } from '@/features/tasks/hooks/form/use-task-form-recurrence';

export const useTaskFormState = (initialTask, tasks, onSave) => {
  const { projectDisplayMap, contextDisplayMap, personDisplayMap, allTasks } =
    useTasksContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [task, setTask] = useState(() =>
    buildInitialTaskFormState(initialTask),
  );
  const recurrenceState = useTaskFormRecurrence(initialTask);

  const { errors, validate } = useTaskFormValidation(task);
  const { subtasks, incompleteSubtasks, calculatedDuration, isRollup } =
    useTaskFormSubtasks(initialTask, tasks);
  const options = useTaskFormOptions(
    projectDisplayMap,
    contextDisplayMap,
    personDisplayMap,
    allTasks,
  );
  const handlers = useTaskFormHandlers({
    task: { ...task, recurrence: recurrenceState.recurrence },
    setTask,
    allTasks,
    isRollup,
    validate,
    onSave,
    setIsSubmitting,
  });

  return {
    task,
    errors,
    isSubmitting,
    isRollup,
    isRecurrenceEnabled: recurrenceState.isRecurrenceEnabled,
    setIsRecurrenceEnabled: recurrenceState.setIsRecurrenceEnabled,
    recurrenceInterval: recurrenceState.recurrenceInterval,
    setRecurrenceInterval: recurrenceState.setRecurrenceInterval,
    recurrenceFrequency: recurrenceState.recurrenceFrequency,
    setRecurrenceFrequency: recurrenceState.setRecurrenceFrequency,
    subtasks,
    calculatedDuration,
    incompleteSubtasks,
    options,
    handlers,
  };
};
